import { render, staticRenderFns } from "./PlatformDocsIcon.vue?vue&type=template&id=3d33ee26&scoped=true"
import script from "./PlatformDocsIcon.vue?vue&type=script&lang=js"
export * from "./PlatformDocsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33ee26",
  null
  
)

export default component.exports